// 카테고리별 증상 그룹. key는 it_observations.symptoms JSONB에 저장되므로 변경 시 주의.
// api/research-case.ts (SYMPTOM_LABELS) 및 api/lib/pubmed.ts (SYMPTOM_QUERY)와
// 동기화 유지. admin 워크스페이스와 아카이브 회고 화면에서 공유한다.

export const SYMPTOM_GROUPS = [
  { cat: "원시반사", items: [
    { k: "ref_moro", l: "모로반사" },
    { k: "ref_galant", l: "갈란트 반사" },
    { k: "ref_atnr", l: "ATNR" },
    { k: "ref_stnr", l: "STNR" },
    { k: "ref_tlr", l: "TLR" },
    { k: "ref_rooting", l: "Rooting" },
    { k: "ref_sucking", l: "Sucking" },
    { k: "ref_babinski", l: "바빈스키" },
    { k: "ref_palmar", l: "팔마" },
  ]},
  { cat: "근긴장도", items: [
    { k: "ton_tongue", l: "혀 긴장도" },
    { k: "ton_tongue_tie", l: "설소대 짧음" },
    { k: "ton_lips", l: "입술 주변 긴장" },
    { k: "ton_larynx", l: "후두 긴장" },
    { k: "ton_swallow", l: "삼킴 기능" },
    { k: "ton_trunk_weak", l: "몸통 근육 약증" },
    { k: "ton_limb_tight", l: "팔다리 근육 긴장" },
  ]},
  { cat: "자세", items: [
    { k: "pos_head_tilt", l: "머리 기울기" },
    { k: "pos_shoulder", l: "어깨 좁고 굽음" },
    { k: "pos_trunk_stab", l: "체간 안정성" },
    { k: "pos_limb_sym", l: "팔다리 대칭 움직임" },
    { k: "pos_pelvic", l: "골반 전방/후방경사" },
    { k: "pos_hand", l: "손가락/손목 사용" },
    { k: "pos_flatfoot", l: "평발" },
    { k: "pos_toe_deform", l: "발가락 변형" },
    { k: "pos_torticollis", l: "사경" },
    { k: "pos_plagio", l: "사두증" },
    { k: "pos_scoliosis", l: "측만증" },
    { k: "pos_kyphosis", l: "후만증" },
  ]},
  { cat: "수면", items: [
    { k: "slp_onset", l: "입면시간" },
    { k: "slp_cycle", l: "수면주기" },
    { k: "slp_rhythm", l: "수면리듬" },
    { k: "slp_bruxism", l: "이갈이" },
    { k: "slp_terror", l: "야경증" },
    { k: "slp_enuresis", l: "야뇨증" },
  ]},
  { cat: "각성", items: [
    { k: "arsl_high", l: "고각성" },
    { k: "arsl_low", l: "저각성" },
    { k: "arsl_hyper", l: "감각과민" },
    { k: "arsl_hypo", l: "감각둔감" },
  ]},
  { cat: "언어", items: [
    { k: "lang_speech", l: "발화" },
    { k: "lang_articul", l: "조음" },
    { k: "lang_phonation", l: "발성" },
    { k: "lang_apraxia", l: "말실행증" },
    { k: "lang_stutter", l: "말더듬증" },
    { k: "lang_mutism", l: "함구증" },
  ]},
  { cat: "정서", items: [
    { k: "emo_anxiety", l: "불안" },
    { k: "emo_ocd", l: "강박" },
    { k: "emo_depress", l: "우울" },
    { k: "emo_bipolar", l: "조울" },
  ]},
  { cat: "호흡", items: [
    { k: "resp_tachypnea", l: "빈호흡" },
    { k: "resp_hyper", l: "과호흡" },
    { k: "resp_mouth", l: "구강호흡" },
    { k: "resp_nasal", l: "비강호흡" },
    { k: "resp_apnea", l: "수면 무호흡" },
    { k: "resp_hold", l: "숨참음" },
    { k: "resp_sigh", l: "한숨" },
  ]},
  { cat: "감각 · 시각", items: [
    { k: "sens_v_strabismus", l: "사시" },
    { k: "sens_v_hyperopia", l: "원시" },
    { k: "sens_v_myopia", l: "근시" },
    { k: "sens_v_astigmat", l: "난시" },
    { k: "sens_v_diplopia", l: "복시" },
    { k: "sens_v_cortical", l: "피질시각" },
    { k: "sens_v_amblyopia", l: "약시" },
  ]},
  { cat: "감각 · 청각", items: [
    { k: "sens_a_hyper", l: "과민" },
    { k: "sens_a_loss", l: "소실" },
  ]},
  { cat: "감각 · 후각", items: [
    { k: "sens_o_hyper", l: "과민" },
    { k: "sens_o_hypo", l: "둔감" },
    { k: "sens_o_discrim", l: "식별 어려움" },
    { k: "sens_o_defense", l: "방어" },
  ]},
  { cat: "감각 · 미각", items: [
    { k: "sens_g_pref", l: "맛 선호도" },
    { k: "sens_g_picky", l: "편식" },
  ]},
  { cat: "감각 · 촉각", items: [
    { k: "sens_t_hyper", l: "과민" },
    { k: "sens_t_pain", l: "통각" },
    { k: "sens_t_contact", l: "접촉" },
    { k: "sens_t_hypo", l: "둔감" },
    { k: "sens_t_defense", l: "방어" },
  ]},
  { cat: "감각 · 고유수용", items: [
    { k: "sens_p_pressure", l: "압박감" },
    { k: "sens_p_vestibular", l: "전정감각" },
    { k: "sens_p_balance", l: "균형" },
  ]},
  { cat: "감각 · 내수용", items: [
    { k: "sens_i_aware", l: "자기 몸 자각" },
  ]},
  { cat: "기타", items: [
    { k: "etc_rhinitis", l: "비염" },
    { k: "etc_drooling", l: "침흘림" },
    { k: "etc_chewing", l: "씹는 기능" },
    { k: "etc_bowel", l: "배변" },
    { k: "etc_fatigue", l: "피로도" },
    { k: "etc_stamina", l: "체력저하" },
    { k: "etc_mouth_open", l: "입벌림" },
    { k: "etc_tongue_out", l: "혀내밀기" },
    { k: "etc_nail_biting", l: "손톱뜯기" },
    { k: "etc_lifestyle", l: "생활 습관" },
    { k: "etc_sensory_seeking", l: "감각 추구" },
  ]},
];

// 평탄화된 key → "카테고리 · 항목" 매핑.
export const SYMPTOM_LABEL_MAP = Object.fromEntries(
  SYMPTOM_GROUPS.flatMap((g) => g.items.map((it) => [it.k, `${g.cat} · ${it.l}`])),
);
